"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniversalSearch = exports.UNIVERSAL_SEARCH_MAX_HEIGHT = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const clsx_1 = __importDefault(require("clsx"));
const react_1 = require("react");
const react_2 = require("@emotion/react");
const semantic_ui_react_1 = require("semantic-ui-react");
const router_1 = require("@reach/router");
const context_1 = require("../layout/context");
const help_1 = require("./help");
exports.UNIVERSAL_SEARCH_MAX_HEIGHT = 78;
const UniversalSearch = ({ isLoading, onQuery, children }) => {
    const location = (0, router_1.useLocation)();
    const searchInputRef = (0, react_1.useRef)(0);
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const [{ navigationState }] = (0, context_1.useLayoutContext)();
    (0, react_1.useEffect)(() => {
        function handler(e) {
            switch (e.type) {
                case "click":
                case "wom_click": {
                    setIsOpen(false);
                    break;
                }
                case "keydown":
                case "wom_keydown": {
                    if (e.key === "Escape") {
                        setIsOpen(false);
                    }
                    break;
                }
                default:
                    break;
            }
        }
        document.addEventListener("click", handler);
        document.addEventListener("keydown", handler);
        // These events are coming from WOM
        document.addEventListener("wom_click", handler);
        document.addEventListener("wom_keydown", handler);
        return () => {
            document.removeEventListener("click", handler);
            document.removeEventListener("keydown", handler);
            document.removeEventListener("wom_click", handler);
            document.removeEventListener("wom_keydown", handler);
        };
    });
    (0, react_1.useEffect)(() => {
        setIsOpen(false);
    }, [location.href]);
    const handleInputChange = ({ target }) => {
        if (searchInputRef.current) {
            window.clearTimeout(searchInputRef.current);
        }
        searchInputRef.current = window.setTimeout(() => {
            if (target.value) {
                setIsOpen(true);
            }
            onQuery(target.value);
        }, 800);
    };
    const handleInputClickFocus = () => {
        setIsOpen(true);
    };
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: styles }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, clsx_1.default)("p-5 bg-white universal-search-input-padding", {
                mobile: navigationState !== "desktop",
            }) }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "flex space-x-3 universal-search-input-container items-center", onClick: event => {
                    event.stopPropagation();
                } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "flex-1" }, { children: [(0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Input, Object.assign({ icon: true, iconPosition: "left", fluid: true, loading: isLoading, onChange: handleInputChange, onFocus: handleInputClickFocus, onClick: handleInputClickFocus }, { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Icon, { name: "search", className: "universal-search-input-icon" }), (0, jsx_runtime_1.jsx)("input", { className: "universal-search-input-element border-transparent bg-color-primary", placeholder: "Search for an ASN, Order, RMA, or Sku" })] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "universal-search-results" }, { children: isOpen && children }))] })), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(help_1.UniversalSearchHelpModal, { triggerElement: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, Object.assign({ icon: true, className: "universal-search-info-button" }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Icon, { name: "question", size: "small" }) })) }) })] })) })) })));
};
exports.UniversalSearch = UniversalSearch;
const styles = (0, react_2.css) `
  position: relative;
  max-height: ${exports.UNIVERSAL_SEARCH_MAX_HEIGHT}px;

  .universal-search-input-padding {
    transition: padding 240ms 400ms ease-in;

    &.mobile {
      @media (min-width: 376px) {
        padding-left: 4.8rem;
      }
      padding-right: 4.8rem;
      transition: padding 400ms ease-in;
    }
  }

  .universal-search {
    &-input-icon.icon.search {
      opacity: 1 !important;
      color: var(--primary-color) !important;
    }
    &-input-element {
      padding-left: 3.2em !important;
      border-color: transparent !important;
      background-color: #f1f3fa !important;
    }

    &-results {
      position: relative;
    }

    &-info-button {
      margin: 0;
      width: 2.375em;
      height: 2.375em;
    }
  }
`;
